import React, { Component } from 'react';
import { WithStyles } from 'decorators/withStyles';
import { IUser } from 'interface/user';
import { removeComment, edit, moderate } from 'actionCreators/forum';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton/IconButton';
import MoreVertIcon from 'mdi-react/MoreVertIcon';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import { ICommentInformations, enStatus } from 'interface/forum';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

interface IState {
  open?: boolean;
  anchorEl?: any;
  isOpenDialog: boolean;
  actionDialog?: string;
}

interface IProps {
  comment: ICommentInformations;
  classes?: any;
  user: IUser;
  removeComment: typeof removeComment;
  edit: typeof edit;
  status: string;
  ownerCommentId: string | number;
  userId: string | number;
  moderate?: typeof moderate;
}

@WithStyles({
  noPadding: {
    padding: 0
  }
})
class MenuOptions extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { open: false, isOpenDialog: false };
  }

  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  handleEdit = () => {
    this.props.edit(this.props.comment.id);
    this.handleClose();
  };

  handleDelete = () => {
    this.props.removeComment(this.props.comment.id);
    this.handleCloseDialog();
  };

  handleShowHide = () => {
    this.props.moderate(this.props.comment.id);
    this.handleCloseDialog();
  };

  openDialog = (action: string) => {
    this.setState({ actionDialog: action, isOpenDialog: !this.state.isOpenDialog });
    this.handleClose();
  };

  handleCloseDialog = () => {
    this.setState({ isOpenDialog: !this.state.isOpenDialog });
  };

  buttonsDialogs = () => {
    const { actionDialog } = this.state;
    if (actionDialog === 'delete') {
      return (
        <DialogActions>
          <Button onClick={this.handleCloseDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={this.handleDelete} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      );
    }
    if (actionDialog === 'hide' || actionDialog === 'show') {
      return (
        <DialogActions>
          <Button onClick={this.handleCloseDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={this.handleShowHide} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      );
    }

    return null;
  };

  dialogText = () => {
    const { actionDialog } = this.state;

    if (actionDialog === 'delete') return 'Deseja realmente excluir esse comentário?';

    if (actionDialog === 'hide') return 'Deseja realmente não exibir esse comentário?';

    if (actionDialog === 'show') return 'Deseja realmente exibir esse comentário?';

    return '';
  };

  dialogDescription = () => {
    const { actionDialog } = this.state;

    if (actionDialog === 'delete') return 'Ao confirmar, esse comentário não poderá mais ser visualizado.';

    if (actionDialog === 'hide') {
      return `Ao confirmar, esse comentário só poderá ser visualizado por moderadores.
       Fique tranquilo, você pode desfazer a ação se necessário.`;
    }

    if (actionDialog === 'show') return 'Ao exibir esse comentário, ele estará visível a todos os usuários.';

    return '';
  };

  menuItems = () => {
    const { status, userId, ownerCommentId, comment } = this.props;

    if ((status === enStatus.learner || status === enStatus.producer || status === 'free') && userId === ownerCommentId) {
      return (
        <div>
          <MenuItem onClick={this.handleEdit}>Editar</MenuItem>
          <MenuItem onClick={this.openDialog.bind(this, 'delete')}>Excluir</MenuItem>
        </div>
      );
    }

    if (status === enStatus.producer && userId !== ownerCommentId && !comment.moderate_at) {
      return (
        <div>
          <MenuItem onClick={this.openDialog.bind(this, 'hide')}>Não exibir</MenuItem>
        </div>
      );
    }

    if (status === enStatus.producer && userId !== ownerCommentId && !!comment.moderate_at) {
      return (
        <div>
          <MenuItem onClick={this.openDialog.bind(this, 'show')}>Exibir</MenuItem>
        </div>
      );
    }
    return null;
  };
  render() {
    const { open, isOpenDialog, anchorEl } = this.state;
    const { classes, status, userId, ownerCommentId } = this.props;
    const ITEM_HEIGHT = 48;

    if (status === 'learner' && userId !== ownerCommentId) return null;

    return (
      <div>
        <IconButton
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={this.handleClick}
          className={classes.noPadding}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200
            }
          }}
        >
          {this.menuItems()}
        </Menu>

        <Dialog open={isOpenDialog}>
          <DialogTitle id="alert-dialog-title">{this.dialogText()}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{this.dialogDescription()}</DialogContentText>
          </DialogContent>
          {this.buttonsDialogs()}
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state: any, ownProps: any) => {
  return {
    ...ownProps
  };
};
export default connect(mapStateToProps, { removeComment, edit, moderate })(MenuOptions);
